import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_FEE_RECOMMENDATIONS_ACTION_TYPE } from '../actions';

const initialState = {
  data: null,
};

const feeRecommendationsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_FEE_RECOMMENDATIONS_ACTION_TYPE.GET_FEE_RECOMMENDATIONS:
        draft.data = payload;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default feeRecommendationsReducer;
